import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'yesNo',
  standalone: true,
})
export class YesNoPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(value: boolean | null | undefined): string {
    if (value === null || value === undefined) return '-';

    return value
      ? this.translate.instant('SWAL.YES')
      : this.translate.instant('SWAL.NO');
  }
}
